(() => {
  'use strict';
  const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  const seen = new Set();
  function eligible(a) {
    if (!a || !a.href || a.origin !== location.origin) return false;
    if (!/^\/(products|collections)\//.test(a.pathname)) return false;
    if (a.pathname === location.pathname && a.search === location.search) return false;
    return true;
  }
  function prefetch(a) {
    if (!eligible(a)) return;
    const href = a.href;
    if (seen.has(href)) return;
    seen.add(href);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }
  document.addEventListener('pointerover', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (a) prefetch(a);
  }, { passive: true, capture: true });
  document.addEventListener('touchstart', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (a) prefetch(a);
  }, { passive: true, capture: true });
})();
